
import makerjs from "makerjs";
//已知劣弧上两点坐标及半径，求圆心坐标劣弧中心点坐标。
function optimizedArcMidpoint(start, end, radius) {
  // 1. 预计算差值避免重复计算
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const dSquared = dx * dx + dy * dy;
  
  // 快速检查半径有效性
  if (dSquared > 4 * radius * radius) return null; // 使用平方比较避免开方运算

  // 2. 计算中点（仅需一次加法运算）
  const midX = (start.x + end.x) * 0.5;
  const midY = (start.y + end.y) * 0.5;

  // 3. 计算垂直向量（优化单位化过程）
  const invD = 1 / Math.sqrt(dSquared);
  const ux = dy * invD;  // 单位垂直向量x分量
  const uy = -dx * invD; // 单位垂直向量y分量

  // 4. 计算圆心（单解模式，直接选择劣弧圆心）
  const h = Math.sqrt(radius * radius - dSquared * 0.25);
  const center = {
      x: midX + h * ux,
      y: midY + h * uy
  };

  // 5. 向量法计算中点（优化单位化过程）
  const v1x = start.x - center.x;
  const v1y = start.y - center.y;
  const v2x = end.x - center.x;
  const v2y = end.y - center.y;
  
  // 单位向量相加
  const sumX = v1x + v2x;
  const sumY = v1y + v2y;
  const invLen = radius / Math.sqrt(sumX * sumX + sumY * sumY);
  
  return {
      x: center.x + sumX * invLen,
      y: center.y + sumY * invLen
  };
}

//已知劣弧 半径 弦长 求拱高
// 拱高=半径-（弦长/2）


//已知圆上两个点坐标及圆的半径，求圆心坐标函数
function Circle_Center(x1, y1, x2, y2, r) {
  var a = 0, b = 0, b2 = 0;
  console.log("Circle_Center计算圆心坐标函数")
  console.log("x1, y1, x2, y2, r",x1, y1, x2, y2, r);
  //Math.pow((x1-a),2)+Math.pow((y1-b),2) == Math.pow(r,2)
  //Math.pow((x2-a),2)+Math.pow((y2-b),2) == Math.pow(r,2)
  var c1 = (x2 * x2 - x1 * x1 + y2 * y2 - y1 * y1) / (2 * (x2 - x1));
  var c2 = (y2 - y1) / (x2 - x1);//
  var A = (c2 * c2 + 1);
  var B = (2 * x1 * c2 - 2 * c1 * c2 - 2 * y1);
  var C = x1 * x1 - 2 * x1 * c1 + c1 * c1 + y1 * y1 - r * r;
  b = (-B + Math.sqrt(B * B - 4 * A * C)) / (2 * A);
  b2 = (-B - Math.sqrt(B * B - 4 * A * C)) / (2 * A);
  a = c1 - c2 * b;
  var arr = [a, b, b2];
  console.log("arr==", arr);
  return arr;

};
function B63(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,R = Param[1].param, S1 = Param[2].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       r = R * 1 * myZoom,
       s1 = S1 * 1 * myZoom,
       b = B * 1 * myZoom,
       w=b,h=r,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       hd=s1-Math.sqrt(s1*s1-b*b),
       x0 = 0, x1 = 0, x2 = w, x3 = w, y0 = 0, y1 = h-hd, y2 = h, y3 = 0,glassH = h, glassW = w;

       // 示例用法
const start = { x: x1, y: y1 };
const end = { x: x2, y: y2 };
const radius = s1;
// const midpoint = calculateArcMidpoint(start, end, radius);
const midpoint =optimizedArcMidpoint(start, end, radius);
console.log("输出劣弧中点坐标start=",start); // 输出劣弧中点坐标
console.log("输出劣弧中点坐标end=",end); // 输出劣弧中点坐标
console.log("输出劣弧中点坐标=",midpoint); // 输出劣弧中点坐标
      //  var aa=Circle_Center(x1,y1,x2,y2,r);
      //  console.log("aa====",aa);
      var xm=midpoint.x,ym=midpoint.y;
      
console.log("输出劣弧中点坐标xm,ym=",xm,ym); // 输出劣弧中点坐标
   if (r !== 0) {
       var TxtR = R;
   }  if (s1 !== 0) {
  var TxtS1 = "S1="+S1;
}
   if (w !== 0) {
       var TxtB = B;
   }



   var drawAbnormalShapeB63 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "ArcLine": new makerjs.paths.Arc([x1,y1], [x2,y2], s1, false, true),
        "RightLine": new makerjs.paths.Line([x2, y2], [x3, y3]),
        "BottomLine": new makerjs.paths.Line([x3, y3], [x0, y0]),
       }
   };
   var drawAbnormalShapeB63MarkR = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x3 + markShift, y3], [x2 + markShift, y2]),
        "LeftShortUpline": new makerjs.paths.Line([x2, y2], [x2 + 2 * markShift, y2]),
        "LeftShortDnline": new makerjs.paths.Line([x3, y3], [x3 + 2 * markShift, y3]),
       }
   };
   var drawAbnormalShapeB63MarkS1 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([xm+b/4, ym-b/4], [xm, ym]),
        // "UpShortLfline": new makerjs.paths.Line([x1, y2], [x1, y2 + 2 * markShift]),
        // "UpShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
       }
   };
   var drawAbnormalShapeB63MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x3, y3 - markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB63MarkB, TxtB, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字  
   makerjs.model.addCaption(drawAbnormalShapeB63MarkS1, TxtS1, [xm+b/4, ym-b/4-markShift], [xm+b/4+2*markShift, ym-b/4-markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB63MarkR, TxtR, [x3 + 2*markShift, y3], [x2 + 2*markShift, y2]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeB63: drawAbnormalShapeB63,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB63: drawAbnormalShapeB63,
        drawAbnormalShapeB63MarkS1: drawAbnormalShapeB63MarkS1,
        drawAbnormalShapeB63MarkR:drawAbnormalShapeB63MarkR,
        drawAbnormalShapeB63MarkB:drawAbnormalShapeB63MarkB
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B63;